<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1" id="dedication"><a id="page_v">In memory of Marilyn Young (1937–2017), whose brilliant historical scholarship challenges us to confront America’s addiction to war.</a></p><a id="page_v">
</a><p class="ded"><a id="page_v">And to Spelman College activists, past and present, in their courageous struggle for a more just and democratic world.</a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7dcbe662